import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource"; 

import { RecolectarGuiaModal, RADModel } from "./modal";
/**Muestra el modal de RAD y marca una guia como recolectada  */
export async function marcarGuiaRecolectada(idGuia: number, showModal: kea.ShowModalFunc)  {
    const result = await showModal(RecolectarGuiaModal, undefined, { } as RADModel);
    if(result.result) {
        await resources.RecoleccionDomicilio.RecolectarDomicilioGuia({
            IdGuia: idGuia,
            FolioRecoleccion: result.value.folioRecoleccion
        });
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/rad/index.tsx